import { render, staticRenderFns } from "./DrawTools.vue?vue&type=template&id=b504a70a&scoped=true&"
import script from "./DrawTools.vue?vue&type=script&lang=js&"
export * from "./DrawTools.vue?vue&type=script&lang=js&"
import style0 from "./DrawTools.vue?vue&type=style&index=0&id=b504a70a&scoped=true&lang=css&"
import style1 from "./DrawTools.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b504a70a",
  null
  
)

export default component.exports